import type React from "react";
import { Badge } from "@/components/ui/badge";

interface ChatRoomParticipantsBadgesProps {
  displayTitle?: string | null;
}

const splitDisplayTitle = (displayTitle: string) =>
  displayTitle
    .split(",")
    .map((name) => name.trim())
    .filter(Boolean);

export const ChatRoomParticipantsBadges: React.FC<
  ChatRoomParticipantsBadgesProps
> = ({ displayTitle }) => {
  if (!displayTitle) {
    return null;
  }

  const names = splitDisplayTitle(displayTitle);
  if (names.length === 0) {
    return null;
  }

  const badges = names.map((name, index) => ({
    name,
    key: `${name}-${index}`,
  }));

  return (
    <div className="flex max-w-full flex-nowrap items-center gap-1 overflow-hidden">
      {badges.map(({ name, key }) => (
        <Badge
          key={key}
          variant="secondary"
          className="pointer-events-none select-none border border-rw-gray-200 bg-rw-gray-210 px-1.5 py-0 text-[9px] leading-4 text-rw-mid-gray"
        >
          {name}
        </Badge>
      ))}
    </div>
  );
};
